module.exports = __webpack_public_path__ + "assets/img/list_msg_sp.26c9b1ee.svg";